import { ReceiptModel } from "./receipt.model";

export class LoadReceipt {
  static readonly type = '[Receipt] LoadReceipt';
}

export class AddReceipt {
  static readonly type = '[Receipt] AddReceipt';
  constructor(public data: ReceiptModel) {}
}

export class RemoveReceipt {
  static readonly type = '[Receipt] RemoveReceipt';
}